const toRate = (value) => Number(value) || 0;

/** True when the invoice carries its own saved IGST/SGST/CGST percentages. */
const hasSavedTaxRates = (taxRates) =>
  taxRates != null &&
  ["IGST", "SGST", "CGST"].some((key) => taxRates[key] != null);

/**
 * GST percentages for the e-invoice payload.
 * Uses the rates saved on the invoice; only falls back to the legacy 18%
 * (9+9 for Gujarat, else 18 IGST) when none were supplied.
 */
const resolveGstRates = (gstNumber, taxRates) => {
  if (hasSavedTaxRates(taxRates)) {
    const igstRate = toRate(taxRates.IGST);
    const cgstRate = toRate(taxRates.CGST);
    const sgstRate = toRate(taxRates.SGST);
    return {
      igstRate,
      cgstRate,
      sgstRate,
      totalRate: igstRate + cgstRate + sgstRate,
    };
  }

  const isGujarat = (gstNumber || "").substring(0, 2) === "24";
  return isGujarat
    ? { igstRate: 0, cgstRate: 9, sgstRate: 9, totalRate: 18 }
    : { igstRate: 18, cgstRate: 0, sgstRate: 0, totalRate: 18 };
};

export default resolveGstRates;
